import classNames from "classnames"
import React from "react"

import { Label3, Paragraph2 } from "@bounce/design-system"
import { useFormatIsoDate, useFormatRelativeDate } from "@bounce/i18n"

import { useReviewUsername } from "@/hooks/useReviewUsername"
import type { Review } from "@/utils/reviews"

import StarIcon from "@bounce/assets/icons/Star-filled.svg"

export type StoreSliderCardReviewProps = {
  review: Review
  className?: string
}

export const StoreSliderCardReview = ({ review, className }: StoreSliderCardReviewProps) => {
  const formatRelative = useFormatRelativeDate()
  const formatIsoDate = useFormatIsoDate()
  const reviewUsername = useReviewUsername({ review })

  return (
    <div className={classNames("flex flex-col gap-2", className)}>
      <div className="flex items-center gap-1">
        <div className="flex items-center gap-0.5">
          {Array.from({ length: review.rating }).map((_, index) => (
            <StarIcon key={index} className="size-4 text-neutral-800" />
          ))}
        </div>
      </div>
      <Paragraph2 className="line-clamp-3 text-neutral-800">{review.translatedFeedback || review.feedback}</Paragraph2>
      <div className="flex">
        <Label3 className="text-neutral-800">
          <span className="mr-1">{reviewUsername}</span>
          <span>
            <time dateTime={formatIsoDate(review.completedAt)} suppressHydrationWarning>
              {formatRelative(review.completedAt)}
            </time>
          </span>
        </Label3>
      </div>
    </div>
  )
}
